import { timeout } from 'promise-timeout'

class DataManager {
  liveQuerys = []

  constructor (options) {
    this.$vueParse = options.$vueParse
    this.$store = options.$store
    this.$ls = options.$ls
  }

  setDevice (route) {
    let dm = this
    return new Promise((resolve, reject) => {
      if (route.query.deviceId) {
        let id = route.query.deviceId
        if (dm.$store.getters.device && dm.$store.getters.device.get('data').id === id) {
          resolve(dm.$store.getters.device)
        }
        if ((!dm.$store.getters.device) || (dm.$store.getters.device.get('data').id !== id)) { // device is not the current
          dm.$vueParse.device.getById(id).first()
            .then(device => {
              if (device) { // device found
                dm.$store.commit('saveDevice', device)
                resolve(device)
              } else { // device not found, we call the config form
                reject(new Error('Device not found'))
              }
            }).catch(error => {
              console.log(error)
              reject(error)
            })
        } else { // device is already the current
          resolve(dm.$store.state.device)
        }
      }
    })
  }

  getData (route) {
    var siteCode = route.params.hotel
    if (this.$vueParse) {
      timeout(this.$vueParse.site.get(siteCode).first(), 10000)
      .then(site => {
        site.fetch().then(site => {
          this.$store.commit('setReadCache', false)
          this.$store.commit('saveSite', site)
          this.initLiveQuery(site)
        })
      }).catch(error => {
        switch (error.code) {
          case 209: // Invalid session token
            // this.$vueParse.Parse.User.logOut()
            // location.reload()
            console.log(error)
            break
          case 119: // permission denied
            if (this.$store.state.user) {
              this.error = {
                title: 'permission denied',
                message: 'unauthorized user'
              }
            } else {
              this.error = {
                title: 'permission denied',
                message: 'login required'
              }
            }
            break
          default:
            // read cache
            console.log(error.message)
            this.$store.commit('setReadCache', true)
            setTimeout(() => {
              this.getData(route)
            }, 1000 * 10) // Try to reconnect after 10s
        }
      }
      )
    }
  }

  initLiveQuery (site) {
    console.log('initLiveQuery')
    this.subscribe('Site', site.id, site)
    if (site.get('rates')) {
      this.subscribe('Rates', site.get('rates').id, site)
    }
    if (site.get('change')) {
      this.subscribe('Change', site.get('change').id, site)
    }
    if (site.get('messages')) {
      this.subscribe('Messages', site.get('messages').id, site)
    }
  }

  subscribe (className, id, site) {
    if (!(id in this.liveQuerys)) { // ensure each subscription is made only once
      var query = new this.$vueParse.Parse.Query(className)
      query.equalTo('objectId', id)
      var subscription = query.subscribe()
      this.liveQuerys[id] = subscription
      console.log('Subscribe to', className, id)
      subscription.on('update', (data) => {
        console.log('Data updated', data)
        site.fetch().then(site => {
          console.log('Savesite', site)
          this.$store.commit('saveSite', site)
        })
      })
    }
  }
}

export default {
  install: (Vue, options = {}) => {
    const name = options.name || 'dm'

    let dataManager = new DataManager(options)

    Vue[name] = dataManager
    Vue.prototype[`$${name}`] = dataManager
  }
}



// WEBPACK FOOTER //
// ./src/tools/data/dataManager.js